const _separator = {
    array: "|",
    date: "/",
    time: ':'
};
export default _separator;
